import { useEffect } from "react";
import { PageContent, PageHead, PageHeadImage } from "../../../components/layout";
import { setDocumentTitle } from "../../../utils";

export const AcademyEducationPage = () => {
    useEffect(() => {
        setDocumentTitle(`Образовательная организация - Официальный сайт Академия «Родина»`);
    }, []);
    return (
        <>
            <div className="w-full relative">
                <PageHeadImage
                    src="https://academy.fcrodina.com/news/184f681280e2a801af2ebc92a106eb3b.jpg"
                    alt="Сведения об образовательной организации"
                />
            </div>
            <div className="p-2 sm:p-8 max-w-[1024px] mx-auto">
                <h1 className="py-4 sm:pb-8 text-2xl sm:text-3xl font-semibold text-center text-slate-950">Сведения об образовательной организации</h1>
                <h2 className="text-xl font-medium">Образование</h2>
                <div className="px-4 py-6">
                    <h3 className="text-lg">1. Реализуемые образовательные программы</h3>
                    <p className="px-4 py-6 whitespace-pre">
                        {
`Дополнительная образовательная программа спортивной подготовки по виду спорта «футбол» АНО "Футбольная клуб "Родина"

    -  Форма обучения: очная;

    -  Срок обучения: 9 лет;

    -  Язык обучения: русский;
                `}
                    </p>

                    <h3 className="text-lg">2. Образовательные программы</h3>
                    <p className="px-4 py-6">
                        Дополнительная образовательная программа спортивной подготовки по виду спорта «футбол»
                        АНО "Футбольная клуб "Родина"  предназначена для организации образовательной
                        деятельности по спортивной подготовке «футбол» с учетом совокупности минимальных
                        требований к спортивной подготовке, определенных федеральным стандартом спортивной
                        подготовки по виду спорта «футбол», утвержденным приказом Минспорта России 16.11.2022 г.
                        № 1000 (далее - ФССП).
                    </p>
                    <p className="px-4 py-6">
                        <h3 className="text-lg">
                            <a
                                href="https://academy.fcrodina.com/uploads/images/docs/education.pdf"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-sky-500 hover:text-sky-400"
                            >
                                Полная информация о программе
                            </a>
                        </h3>
                    </p>
                </div>
            </div>
        </>
    );
};